import React, { useCallback } from 'react';
import ModalPreventForm from '../../../../components/modal-prevent/ModalPreventForm';
import { getPreventLeaveText } from '../../../../components/modal-prevent/utils';

type Props = {
  open: boolean;
  approveCallback: () => void;
  cancelCallback: () => void;
};

const ProjectStatusChangeConfirmModal = ({ open, approveCallback, cancelCallback }: Props) => {
  const redirectTexts = getPreventLeaveText();

  const cancelHandler = useCallback(() => {
    cancelCallback();
  }, [cancelCallback]);

  const approveHandler = useCallback(() => {
    approveCallback();
  }, [approveCallback]);

  return (
    <ModalPreventForm
      open={open}
      cancelHandler={cancelHandler}
      approveHandler={approveHandler}
      onEscapeKeyDown={() => { setTimeout(() => { approveHandler(); }, 250); }}
      title={redirectTexts.title}
      message={redirectTexts.message}
      approveText={redirectTexts.approveText}
      cancelText={redirectTexts.cancelText}
    />
  );
};

export default ProjectStatusChangeConfirmModal;
